module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms2_jp.62b781740dda903cb91888ccced11567.png";